// The API's alias_200 proof authorizes primary content, not a browser redirect.
// Keep this limited to verified pre-cutover LP addresses on BookAClassic.
import { legacyLpDisposition } from "../../../../lib/copy/src/legacy-lp-readiness.mjs";
export function verifiedLpAliasPath(lookup, pathname, hostname, legacySeoEnabled) {
  const scoped = legacyLpDisposition(pathname);
  if (scoped?.kind === "page" && lookup?.page &&
      `/${String(lookup.page.full_path).replace(/^\/+|\/+$/g, "")}` === scoped.contentPath)
    return pathname;
  if (legacySeoEnabled || !/^(?:www\.)?bookaclassic\.com$/i.test(hostname) ||
      !pathname.startsWith("/lp/") || lookup?.routePolicy?.kind !== "alias_200" ||
      !lookup.page) return undefined;
  const normal = value => `/${String(value || "").replace(/^\/+|\/+$/g, "")}`;
  if (normal(lookup.routePolicy.alias) !== normal(pathname) ||
      normal(lookup.routePolicy.canonical) !== normal(lookup.page.full_path)) return undefined;
  return pathname;
}

export function verifiedFaqAliasPath(pathname, hostname, legacySeoEnabled, canonicalOrigin) {
  if (legacySeoEnabled || !/^(?:www\.)?bookaclassic\.com$/i.test(hostname) ||
      !/^https:\/\/www\.bookaclassic\.com$/.test(canonicalOrigin)) return undefined;
  // Exact supplied paths with captured alias -> primary FAQ content evidence.
  return ["/faq-renter/", "/faq-procedures/"].includes(pathname) ? pathname : undefined;
}
